import React, { useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { light, dark } from './styles/Theme';
import AppRouter from './router/AppRouter';
import { AuthContextProvider } from './contexts/AuthContext';
import { CartContextProvider } from './contexts/CartContext';
import { NotificationProvider, useNotification } from './contexts/NotificationContext';
import SettingsContext from './contexts/SettingsContext';
import { FavouriteContextProvider } from './contexts/FavouriteContext';
import { setErrorHandler } from './services/api';

const ErrorHandlerInitializer = ({ children }) => {
  const { showError } = useNotification();
  
  React.useEffect(() => {
    setErrorHandler(showError);
  }, [showError]);

  return children;
};

function App() {
  const settings = useContext(SettingsContext);
  const theme = settings.isDarkMode ? dark : light;

  return (
    <NotificationProvider>
      <AuthContextProvider>
        <FavouriteContextProvider>
          <CartContextProvider>
            <ThemeProvider theme={theme}>
              <StylesThemeProvider theme={theme}>
                <CssBaseline />
                <ErrorHandlerInitializer>
                  <AppRouter />
                </ErrorHandlerInitializer>
              </StylesThemeProvider>
            </ThemeProvider>
          </CartContextProvider>
        </FavouriteContextProvider>
      </AuthContextProvider>
    </NotificationProvider>
  );
}

export default App;
